module.exports = __webpack_public_path__ + "media/components/resources/download-limit-form/img/join-pro-message-bg-dccf01ba22a8682dab0aab06f553c3e5.png";